import { Component } from '@opten/compiler/metadata/component';
import { ComponentRef, ComponentRefs } from '@opten/compiler/metadata/di';
import { OnInit } from '@opten/compiler/metadata/lifecycle';
import { Navbar } from './navbar';
import { isDesktop, isPad } from '../../utilities/detection';
import { NavbarMegaDropdown } from './navbar-mega-dropdown';
import { hasClass } from '@opten/dom/has-class';
import { removeClass } from '@opten/dom/remove-class';

@Component({ className: 'js-navbar-toggler' })
export class NavbarToggler implements OnInit {
    @ComponentRef(Navbar) _navbar: Navbar;
    @ComponentRefs(NavbarMegaDropdown) _dropdowns: Array<NavbarMegaDropdown>;

    constructor(private element: HTMLElement) { }

    onInit() {
        this.element.addEventListener('click', event => {
            event.preventDefault();
            this._handleClick(event);
        });
        this.element.addEventListener('blur', (event) => {
            if (isDesktop() &&(event.target as HTMLElement).parentElement.matches(':focus-within') === false) {
                this._handleClick(event as MouseEvent);
            }
        });
    }

    private _handleClick(event: MouseEvent) {
        if (hasClass(document.body, 'modal--is-open') === false) {
            if (isPad()) {
                if (hasClass(this._navbar.navbarElement, '--mega-dropdown--open')) {
                    this.hideDropdowns(event);                  
                    removeClass(this._navbar.navbarElement, '--mega-dropdown--open');
                }
                else {
                    this._navbar.toggle();
                }
            } else {
                this.hideDropdowns(event);
            }
        }
    }

    hideDropdowns(event: Event) {
        const target = event.target as HTMLElement;

        target.blur(); // remove focus

        if (this._dropdowns && this._dropdowns !== undefined) {
            this._dropdowns.forEach(dropdown => dropdown.hide());
        }
    }
}
